import api from "@/services/api";
// @ts-expect-error - api is not typed
const { get, post } = api.getPrefixedMethods("orderinfo");
const recapPath = (orderKey) => `submission/${orderKey}/recap/`;
export const orderRecapService = {
    get: (orderKey) => get(recapPath(orderKey)),
    refresh: (orderKey) => post(recapPath(orderKey), {}),
    rate: (orderKey, version, rating, reason = "") => post(`${recapPath(orderKey)}feedback/`, { rating, reason, version }),
};
